module.exports = __webpack_public_path__ + "02_long_brown.42df972d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_long_brown.png
// module id = OiAc
// module chunks = 0